import type { ReactNode } from "react";

export type AlertVariant = "error" | "info" | "success" | "warning";

export interface AlertProps {
  children: ReactNode;
  title?: string;
  variant?: AlertVariant;
}

const variantClasses: Record<AlertVariant, string> = {
  error: "border-danger/30 bg-danger-subtle text-danger",
  info: "border-info/30 bg-info-subtle text-info",
  success: "border-positive/30 bg-positive-subtle text-positive",
  warning: "border-caution/30 bg-caution-subtle text-caution",
};

export function Alert({ children, title, variant = "error" }: AlertProps) {
  const isActionableFailure = variant === "error";

  return (
    <div
      className={`rounded-lg border p-4 ${variantClasses[variant]}`}
      role={isActionableFailure ? "alert" : "status"}
    >
      {title && <p className="font-semibold">{title}</p>}
      <div className={title ? "mt-1 text-sm" : "text-sm"}>{children}</div>
    </div>
  );
}
